// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"214":"85a95fa4","226":"6217cbee","454":"e5e85330","583":"cca2d958","739":"dd24cf9e","965":"e32f354c"}[chunkId] + ".chunk.js";
};